import { useQuery } from '@tanstack/react-query';

import { useWmgSession } from '~/modules/auth/hooks/useWmgSession';

import { DdexClient } from '../lib/DdexClient';
import { getRequestHeaders } from '../lib/headers';

interface DownloadDdexFileResponse {
  presigned_url: string;
}

export function useGetDdexDownloadLink(id: string) {
  const session = useWmgSession();

  return useQuery<DownloadDdexFileResponse>({
    queryKey: ['downloadDdexFile', id],
    queryFn: async () => {
      try {
        const response = await DdexClient.get(`v1/releases/download/${id}`, {
          headers: getRequestHeaders(session.token),
        }).json<DownloadDdexFileResponse>();

        return response;
      } catch (error) {
        console.error('Failed to fetch download URL:', error);

        throw error;
      }
    },
    enabled: false,
  });
}
